import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type FlyoverState = {
  isOpen: boolean;
};

export const initialState: FlyoverState = {
  isOpen: false
};

export const flyoverSlice = createSlice({
  name: 'flyover',
  initialState,
  reducers: {
    setFlyoverOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    }
  }
});

export const { setFlyoverOpen } = flyoverSlice.actions;

export const flyoverReducer = flyoverSlice.reducer;
